import React from 'react';
import { ThemeProvider } from '../../contexts/ThemeContext';
import { CallsScreen } from '../../pages/CallsScreen';
import { BottomTabBar } from '../ui/BottomTabBar';
import { DeckPhoneFrame } from './DeckPhoneFrame';
interface VexuCallsShowcaseProps {
  scale?: number;
}

/**
 * Emergency handling gets its own reveal later in the deck, so the emergency
 * call is omitted from the list shown here.
 */
const EMERGENCY_CALL_IDS = [12];

/**
 * The real Vexu Calls experience inside a presentation device shell.
 * `initialCallId` is only used to seed the product's own call history —
 * it references no call, so the list view stays open.
 */
export function VexuCallsShowcase({
  scale = 0.68
}: VexuCallsShowcaseProps) {
  return <ThemeProvider initialMode="light" data-id="element-304" data-mp="2wys0avbh6d4y">
      <DeckPhoneFrame scale={scale} data-id="element-305" data-mp="z7p4vswiddsi">
        <div className="h-full relative pointer-events-none select-none" aria-hidden="true" data-id="element-306" data-mp="z6ntfnbkypa9">
          <CallsScreen onNavigate={() => undefined} initialCallId={-1} hiddenCallIds={EMERGENCY_CALL_IDS} data-id="element-307" data-mp="v6lo946mzdq8" />
          <BottomTabBar currentTab="calls" onTabChange={() => undefined} data-id="element-308" data-mp="1kv3qdgbut22b" />
        </div>
      </DeckPhoneFrame>
    </ThemeProvider>;
}